import {useState} from 'react';
import {getVideoEmbedCode} from "../utils/video";

const sponsorTiers = {
    sustaining: [],
	partner: [],
	platinum: [],
    gold: [],
    silver: [],
    bronze: [],
    copper: [],
    supporting: [],
}

function formatEventData(rawEventData) {
    const endDateTime = new Date(rawEventData.msevtmgt_eventenddate);
    const startDateTime = new Date(rawEventData.msevtmgt_eventstartdate);
    const sortedSponsors = sortSponsors(rawEventData.sponsors);
    const eventHasExternalRegistrationUrl = rawEventData.bio_externalregistrationurl && rawEventData.bio_externalregistrationurl.length;
    const registrationUrl = eventHasExternalRegistrationUrl ? rawEventData.bio_externalregistrationurl : rawEventData.registrationUrl;

    return {
        endDateTime: endDateTime.getTimezoneOffset(),
        eventDatesUnformatted: {
            start: rawEventData.msevtmgt_eventstartdate,
            end: rawEventData.msevtmgt_eventenddate,
        },
        sponsors: sortedSponsors.data,
        startDateTime: startDateTime.toString(),
        venue: {
            name: rawEventData?.['location.msevtmgt_name'] ?? null,
            street: rawEventData?.['location.msevtmgt_addressline1'] ?? null,
            city: rawEventData?.['location.msevtmgt_city'] ?? null,
            state: rawEventData?.['location.msevtmgt_stateprovince'] ?? null,
            zip: rawEventData?.['location.msevtmgt_postalcode'] ?? null,
        },
        offsiteRegistration: eventHasExternalRegistrationUrl,
        registrationUrl: registrationUrl,
        sponsorCount: sortedSponsors.count,
		videoEmbed: getVideoEmbedCode(rawEventData.bio_videourl),
    }
}

function sortSponsors(sponsors) {
    const sortedSponsors = {...sponsorTiers}
    let sponsorCounter = 0;
    sponsors.forEach(sponsor => {
        const validSponsorTier = sponsor.sponsorTier !== null && sponsorTiers.hasOwnProperty(sponsor.sponsorTier.toLowerCase())
        const wellFormedSponsor = validSponsorTier && sponsor.imageUrl && sponsor.url;

        if (wellFormedSponsor) {
            const tier = sponsor.sponsorTier.toLowerCase();

            sortedSponsors[tier].push(sponsor)
            sponsorCounter += 1;
        }
    })

    return {
        data: sortedSponsors,
        count: sponsorCounter,
    }
}

export default function useEventData() {
    const [data, setData] = useState({
        description: '',
        name: '',
        sessions: [],
        speakers: [],
        sponsors: sponsorTiers,
        sponsorCount: 0,
    });

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false)

    async function request() {
        setLoading(true);
        const crmUuid = window.massbioEventData.eventCrmUuid;
        let eventsApi = window.massbioEventData.eventsApi;

		// Since the Events API URL can be user defined, we need to ensure it has a trailing slash.
		if (!eventsApi.endsWith('/')) {
			eventsApi += '/';
		}

        const response = await fetch(`${eventsApi}${crmUuid}`, {
            headers: {
                "Content-type": "text/json",
            }
        })
            .then(response => response.json())
            .then(response => {
                return response[0];
            })
            .catch(error => {
                setError(error.message)
            })

        if (response === undefined) {
            setLoading(false)
            return;
        }

        const eventFormattedData = formatEventData(response);
        const event = {
            ...response,
            ...eventFormattedData,
        }

        setData(event);
        setLoading(false)
        setLoaded(true);
    }

    return {
        data,
        error,
        loaded,
        loading,
        request
    };
}
